import { render, staticRenderFns } from "./OCT.vue?vue&type=template&id=1aac0cd4&scoped=true&"
import script from "./OCT.vue?vue&type=script&lang=js&"
export * from "./OCT.vue?vue&type=script&lang=js&"
import style0 from "./OCT.vue?vue&type=style&index=0&id=1aac0cd4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aac0cd4",
  null
  
)

export default component.exports